import { Box, Button, Checkbox, CircularProgress, Divider, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import { AwardIcon } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import apiClient from '../../utils/apiClient'

const AddEditDeliveryRange = () => {
    const location = useLocation()
    const deliveryRange = location?.state?.deliveryRange || ''
    const [formData, setFormData] = useState({
        id: "",
        fee: "",
        fromKm: '',
        toKm: "",
        isActive: true,
        isDeleted: false,

    })
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [validateErrors, setValidateErrors] = useState({})
    const navigate = useNavigate()

    useEffect(() => {
        if (deliveryRange) {
            setFormData(deliveryRange)
        }
    }, [deliveryRange])

    const handleInputChange = (e) => {
        const { name, value } = e.target;


        setFormData(prev => ({ ...prev, [name]: value }));
        setValidateErrors(prev => ({ ...prev, [name]: '' }));


        setError('');
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    const validateForm = () => {
        const errors = {};
        if (formData.fee === '' || isNaN(formData.fee)) {
            errors.fee = "Fee amount is required";
        } else if (formData.fee < 0) {
            errors.fee = "Fee cannot be negative";
        }
        if (formData.fromKm === '' || isNaN(formData.fromKm)) {
            errors.fromKm = "From Km is required";
        }
        if (formData.toKm === '' || isNaN(formData.toKm)) {
            errors.toKm = "To Km is required";
        }

        return errors;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setValidateErrors(errors);
            return;
        }
        setLoading(true);
        try {
            let response;
            if (deliveryRange.id) {
                response = await apiClient.put(`/deliveryrange/updaterange/${deliveryRange.id}`, formData);
            }

            if (response?.data?.status === true) {
                toast.success(response?.data?.message)
                navigate(-1);
            }

        }
        catch (error) {
            setError(error?.response?.data?.message || 'Error updating delivery range')
        }
        finally {
            setLoading(false);
        }
    }
    return (
        <>

            <Box sx={{ backgroundColor: '', padding: 3 }}>
                <Typography variant="h4" sx={{ mb: 3 }}>
                    Add/Edit Delivery Range
                </Typography>
                <Divider sx={{ marginBottom: 3 }} />
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {/* Description */}
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="Fee"
                                name="fee"
                                fullWidth
                                size="small"
                                type='number'
                                value={formData.fee}
                                onChange={handleInputChange}
                                error={!!validateErrors.fee}
                                helperText={validateErrors.fee}
                            />
                        </Grid>

                        {/* Bonus Amount */}
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="From Km"
                                name="fromKm"
                                fullWidth
                                size="small"
                                type="number"
                                value={formData.fromKm}
                                onChange={handleInputChange}
                                error={!!validateErrors.fromKm}
                                helperText={validateErrors.fromKm}
                            />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="To Km"
                                name="toKm"
                                fullWidth
                                size="small"
                                type="number"
                                value={formData.toKm}
                                onChange={handleInputChange}
                                error={!!validateErrors.toKm}
                                helperText={validateErrors.toKm}
                            />
                        </Grid>

                        {/* Checkboxes */}
                        <Grid item size={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isActive"
                                        checked={formData.isActive}
                                        onChange={handleCheckboxChange}
                                        size="small"
                                    />
                                }
                                label="Is Active"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isDeleted"
                                        checked={formData.isDeleted}
                                        onChange={handleCheckboxChange}
                                        size="small"
                                    />
                                }
                                label="Is Deleted"
                            />
                        </Grid>

                        {/* Error Message */}
                        {error && (
                            <Grid item size={12}>
                                <Typography color="error">{error}</Typography>
                            </Grid>
                        )}

                        {/* Submit Button */}
                        <Grid item size={12}>
                            <Box display="flex" justifyContent="end" mt={2} gap={2}>
                                <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
                                    Cancel
                                </Button>
                                <Button type="submit" variant="contained" disabled={loading}>
                                    {loading ? (
                                        <CircularProgress size={24} sx={{ color: '#fff' }} />
                                    ) : (
                                        'Update'
                                    )}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>

            </Box>
        </>
    )
}

export default AddEditDeliveryRange
